import React from 'react';

import { AccountOverviewTab as LegacyAccountOverviewTab } from 'views/account/AccountOverviewTab';

import { useAccountPageView } from '../useAccountPageView';
import { AccountOverviewTab } from './AccountOverviewTab';

export const AccountOverviewRoute = () => {
    const { view } = useAccountPageView();
    return view === 'new' ? <AccountOverviewTab /> : <LegacyAccountOverviewTab />;
};
